module.exports = __webpack_public_path__ + "static/img/4_ranliaodianchi.e7a2172.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/4_ranliaodianchi.png
// module id = Pvda
// module chunks = 0